// extracted by mini-css-extract-plugin
export var activeLink = "pagination-module--active-link--2f7d1";
export var paginationNumbersContainer = "pagination-module--pagination-numbers-container--e7666";
export var paginationWrapper = "pagination-module--pagination-wrapper--e2abf";